import { Tools } from '@/src/store/tools/types';

export function isFeatureCompiled(
  feature:
    | 'annotations'
    | 'cropping'
    | 'segmentation'
    | 'implantPlanning'
    | 'remoteServer'
): boolean {
  switch (feature) {
    case 'annotations':
      return __FEATURE_ANNOTATIONS__;
    case 'cropping':
      return __FEATURE_CROPPING__;
    case 'segmentation':
      // Labelmap painting is always part of the core viewer.
      return true;
    case 'implantPlanning':
      return __FEATURE_IMPLANT_PLANNING__;
    case 'remoteServer':
      return __FEATURE_REMOTE_SERVER__;
    default:
      return false;
  }
}

export function isToolbarToolEnabled(tool: Tools): boolean {
  if (
    tool === Tools.Select ||
    tool === Tools.WindowLevel ||
    tool === Tools.Pan ||
    tool === Tools.Zoom ||
    tool === Tools.Crosshairs
  ) {
    return true;
  }

  if (
    tool === Tools.Ruler ||
    tool === Tools.Rectangle ||
    tool === Tools.Polygon ||
    tool === Tools.Angle ||
    tool === Tools.Arrow ||
    tool === Tools.Circle ||
    tool === Tools.Freehand
  ) {
    return __FEATURE_ANNOTATIONS__;
  }

  if (tool === Tools.Paint) {
    return true;
  }

  if (tool === Tools.Crop) {
    return __FEATURE_CROPPING__;
  }

  if (tool === Tools.CurvedMPRSpline) {
    return __FEATURE_IMPLANT_PLANNING__;
  }

  return false;
}
